import { useCompanyAllowlist } from "./UseCompanyAllowlist";

const PUBLIC_API_KEY_COMPANIES: string[] = [
  '24adbc1c-904c-4091-ba95-46323cd04431',
  'fc7f1442-b048-4a65-b626-fadce6857f7a',
];

export function IsPublicApiKeyEnabled() {
  // Master feature flag (VITE_PUBLIC_API_KEY_ENABLED) — off everywhere by default.
  // The company allowlist only applies once the flag is turned on.
  return useCompanyAllowlist(PUBLIC_API_KEY_COMPANIES);
}
